export default __webpack_public_path__ + "static/media/Download Icon.273571e4.svg";